import React, { useContext } from "react";
import CustomPagination from "./pagination";
import CustomTableHead from "./head";
import ExportButton from "./export";
import InitiateClaimButton from "./initiate";
import NoDataFound from "./noDataFound";
import ListItem from "./listItem";
import SearchBox from "./search";
import StatusFilter from "./filter";
import CustomerDetailsField from "../proposal/partials/customerField";
import UploadPhotoDialog from "../proposal/partials/uploadPhotoDialog";
import AssuranceContext from "../../context/index";
import withStyles from "@material-ui/core/styles/withStyles";
import {
  Box,
  Button,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableContainer,
  Typography,
} from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import { useStyles } from "./styles";
import {
  MODAL_TITLE_CLAIM_REMARKS,
  MODAL_TITLE_DAMAGED_MOBILE_PHOTO,
  MODAL_TITLE_ESTIMATE_PHOTO,
  MODAL_TITLE_INVOICE_PHOTO,
  MODAL_TITLE_REPAIRED_MOBILE_PHOTO,
  SLUG_DAMAGED_MOBILE,
  SLUG_ESTIMATE_MOBILE,
  SLUG_INVOICE_MOBILE,
  SLUG_REPAIRED_MOBILE,
} from "../../constants";
import "react-toastify/dist/ReactToastify.css";

function ClaimsList({
  classes: {
    bgSelected,
    gutterTop,
    listingBox,
    listingItemContainerPolicies,
    policiesListingItemHeader,
    policiesListingItemHeaderHidden,
    policyListingBox,
    question,
    tableBody,
    wordBreak,
  },
  classes,
  downloadFile,
  errors,
  handleChange,
  handleClose,
  handleEstimateClick,
  handleInitiateClaim,
  handleOnClose,
  handlePaymentLinkClick,
  handlePolicyExport,
  handleRemarksClick,
  handleSearchKeyPress,
  isExportClicked,
  isFormSubmitted,
  isPolicyInActive,
  isSearchResultLoaded,
  filter,
  modal,
  onPagination,
  onSearchClickHandler,
  openSearch,
  onSearchChange,
  pagination,
  photo,
  photoChangeHandler,
  submitDamageMobileHandler,
  submitEstimateHandler,
  submitInvoiceHandler,
  submitRepairedMobileHandler,
  uploadClickHandler,
  getClaimsList,
  claimData,
}) {
  const {
    state: {
      filteredClaimsList: list = [],
      filteredClaimsCount: count = 0,
      pageSize,
    },
    state,
    dispatch,
  } = useContext(AssuranceContext);

  return (
    <>
      <Box className={classes.itemContainer}>
        <Box className={listingBox}>
          <Box className={listingItemContainerPolicies}>
            <form onSubmit={onSearchClickHandler}>
              <Box
                className={
                  openSearch
                    ? policiesListingItemHeader
                    : policiesListingItemHeaderHidden
                }
                m={2}
              >
                <SearchBox
                  filter={filter}
                  handleSearchKeyPress={handleSearchKeyPress}
                  onSearchChange={onSearchChange}
                  onSearchClickHandler={onSearchClickHandler}
                  openSearch={openSearch}
                />

                <StatusFilter filter={filter} handleChange={handleChange} />

                <InitiateClaimButton onClickHandler={handleInitiateClaim} />

                <ExportButton
                  handlePolicyExport={handlePolicyExport}
                  isExportClicked={isExportClicked}
                  count={count}
                />
              </Box>
            </form>

            <Box className={policyListingBox}>
              <TableContainer
                component={Paper}
                className={classes.tableContainer}
              >
                <Table stickyHeader aria-label="sticky table">
                  <CustomTableHead />

                  <TableBody className={tableBody}>
                    {count > 0 ? (
                      list
                        .slice(
                          pagination.currentPage * pageSize,
                          (pagination.currentPage + 1) * pageSize
                        )
                        .map((item, index) => {
                          return (
                            <ListItem
                              downloadFile={downloadFile}
                              handleEstimateClick={handleEstimateClick}
                              handlePaymentLinkClick={handlePaymentLinkClick}
                              handleRemarksClick={handleRemarksClick}
                              index={index}
                              isPolicyInActive={isPolicyInActive}
                              item={item}
                              key={index}
                              uploadClickHandler={uploadClickHandler}
                              {...{ getClaimsList, claimData }}
                            />
                          );
                        })
                    ) : (
                      <NoDataFound />
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Box>

        <CustomPagination
          count={count}
          isSearchResultLoaded={isSearchResultLoaded}
          onPagination={onPagination}
        />
      </Box>

      <ToastContainer />

      {modal[SLUG_DAMAGED_MOBILE] && (
        <UploadPhotoDialog
          disabled={!photo[SLUG_DAMAGED_MOBILE] || isFormSubmitted}
          errors={errors}
          filename={SLUG_DAMAGED_MOBILE}
          handleOnClose={handleOnClose}
          modal={modal}
          modalKey={SLUG_DAMAGED_MOBILE}
          photo={photo}
          photoChangeHandler={photoChangeHandler}
          submitHandler={submitDamageMobileHandler}
          title={MODAL_TITLE_DAMAGED_MOBILE_PHOTO}
        />
      )}

      {modal[SLUG_ESTIMATE_MOBILE] && (
        <UploadPhotoDialog
          disabled={!photo[SLUG_ESTIMATE_MOBILE] || isFormSubmitted}
          errors={errors}
          filename={SLUG_ESTIMATE_MOBILE}
          handleOnClose={handleOnClose}
          modal={modal}
          modalKey={SLUG_ESTIMATE_MOBILE}
          photo={photo}
          photoChangeHandler={photoChangeHandler}
          submitHandler={submitEstimateHandler}
          title={MODAL_TITLE_ESTIMATE_PHOTO}
          buttonTitle={"Add Document"}
        />
      )}

      {modal[SLUG_INVOICE_MOBILE] && (
        <UploadPhotoDialog
          disabled={!photo[SLUG_INVOICE_MOBILE] || isFormSubmitted}
          errors={errors}
          filename={SLUG_INVOICE_MOBILE}
          handleOnClose={handleOnClose}
          modal={modal}
          modalKey={SLUG_INVOICE_MOBILE}
          photo={photo}
          photoChangeHandler={photoChangeHandler}
          submitHandler={submitInvoiceHandler}
          title={MODAL_TITLE_INVOICE_PHOTO}
          buttonTitle={"Add Document"}
        />
      )}

      {modal[SLUG_REPAIRED_MOBILE] && (
        <UploadPhotoDialog
          disabled={!photo[SLUG_REPAIRED_MOBILE] || isFormSubmitted}
          errors={errors}
          filename={SLUG_REPAIRED_MOBILE}
          handleOnClose={handleOnClose}
          modal={modal}
          modalKey={SLUG_REPAIRED_MOBILE}
          photo={photo}
          photoChangeHandler={photoChangeHandler}
          submitHandler={submitRepairedMobileHandler}
          title={MODAL_TITLE_REPAIRED_MOBILE_PHOTO}
        />
      )}

      {modal.remark && (
        <Dialog
          open={modal.remark}
          onClose={() => handleClose(false, "remark")}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth={"sm"}
          fullWidth={true}
        >
          <DialogTitle id="alert-dialog-title">
            {MODAL_TITLE_CLAIM_REMARKS}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Grid container spacing={3}>
                {state.remarks.map((item, index) => {
                  return (
                    <Grid item xs={12} className={bgSelected}>
                      <Box
                        className={gutterTop}
                        justifyContent={"left"}
                        textAlign="left"
                      >
                        <Typography
                          variant={"body2"}
                          gutterBottom
                          className={item.status_label
                            .toLowerCase()
                            .replaceAll(" ", "_")}
                        >
                          {item.status_label}
                        </Typography>
                        <Typography
                          variant={"body2"}
                          className={`${question} ${wordBreak}`}
                        >
                          {item.remark}
                        </Typography>
                      </Box>
                    </Grid>
                  );
                })}
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              variant={"contained"}
              size={"small"}
              onClick={() => handleClose(false, "remark")}
              color="secondary"
              autoFocus
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
}


export default withStyles(useStyles, { withTheme: true })(ClaimsList);
